import React from "react";
import { IoHomeOutline } from "react-icons/io5";
import { MdOutlineKeyboardArrowRight } from "react-icons/md";
import { Link } from "react-router-dom";
import AccordionArea from "../../components/AccordionArea";

const Sorular = () => {
  return (
    <div className="containerMain flex flex-col gap-4 divide-y-2">
      <div className="top flex flex-col gap-4">
        <div className="text-sm text-grayy flex items-center gap-2 font-medium">
          <IoHomeOutline className="w-4 h-4" />
          <Link to="/">Anasayfa</Link>
          <MdOutlineKeyboardArrowRight className="w-6 h-6" />
          <span className="text-darkerGreen">Sıkça Sorulan Sorular</span>
        </div>
        <div className="flex flex-wrap items-center p-8 gap-8">
          <h1 className="text-5xl leading-[56px] text-left font-bold text-dark max-w-[362px]">
            Sıkça Sorulan Sorular ?
          </h1>
          <p className="text-base font-normal leading-6 text-left text-dark flex-1">
            Bu sayfa, aklınızdaki bazı soruları yanıtlamanıza yardımcı olacak.
            Eğer burada bulamadığınız bir sorunuz olursa, bizimle iletişime
            geçmekten çekinmeyin. Ekibinizle verimli bir şekilde çalışmanıza
            yardımcı olmayı hedefliyoruz!
          </p>
        </div>
      </div>
      <div className="sorular pt-8">
        <AccordionArea page="sss" />
      </div>
    </div>
  );
};

export default Sorular;
